import { useRequiredContext } from 'legacy/contexts/utils'
import { WarehouseContext } from 'utils/contexts/warehouse/WarehouseContext'

export const useWarehouseContext = () => useRequiredContext(WarehouseContext)
